import { createContext } from "react";
import { TContext } from "./types";

const fnBadCall = () => {
  throw new Error("Bad call");
};
const Context = createContext<TContext>({
  isLoading: { value: false, update: fnBadCall },
  items: { value: [], update: fnBadCall },
  expanded: { value: [], update: fnBadCall },
  showLog: { value: null, update: fnBadCall },
  filter: { value: {}, update: fnBadCall },
  perPage: { value: 10, update: fnBadCall },
  page: { value: 0, update: fnBadCall },
  isLastPage: { value: true, update: fnBadCall },
  loader: fnBadCall,
  lastIdByPage: { value: [], update: fnBadCall },
});

export default Context;
